module.exports = __webpack_public_path__ + "static/media/checklist-blue.14c447c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/checklist-blue.svg
// module id = 2326
// module chunks = 1